var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6622 1.34984C16.1879 0.875515 15.4217 0.875515 14.9474 1.34984L9.00008 7.28498L3.05279 1.33768C2.57846 0.863353 1.81225 0.863353 1.33792 1.33768C0.863597 1.812 0.863597 2.57822 1.33792 3.05254L7.28522 8.99984L1.33792 14.9471C0.863597 15.4215 0.863597 16.1877 1.33792 16.662C1.81225 17.1363 2.57846 17.1363 3.05279 16.662L9.00008 10.7147L14.9474 16.662C15.4217 17.1363 16.1879 17.1363 16.6622 16.662C17.1366 16.1877 17.1366 15.4215 16.6622 14.9471L10.7149 8.99984L16.6622 3.05254C17.1244 2.59038 17.1244 1.812 16.6622 1.34984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modalClose.579d162fd1a6e6285e226e8a21bf6d6b.svg";
export { ForwardRef as ReactComponent };